import {CustomerProductCategoryOverviewRestDto} from "@/api/pharma-cpc-product-category-mgmt/models";

export class CustomerProductCategoryTreeNode {
    public customerCategory: CustomerProductCategoryOverviewRestDto | null;
    public code: string;
    public name: string;
    public children: CustomerProductCategoryTreeNode[];

    constructor(
        customerCategory: CustomerProductCategoryOverviewRestDto | null,
        code: string,
        name: string,
        children: CustomerProductCategoryTreeNode[]
    ) {
        this.children = children;
        this.name = name;
        this.code = code;
        this.customerCategory = customerCategory;
    }
}
